const normalizeText = (value = '') => String(value || '').trim();

const toIsoStringOrNull = (value = null) => {
  if (!value) return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value.toISOString();
  }

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date.toISOString();
};

export const getMedicationReviewOriginEntryId = (source = {}) => (
  normalizeText(
    source.originEntryId
    || source.entryId
    || source.timelineEntryId
    || source.sourceNoteId
    || source.id
  )
);

export const getMedicationReviewOriginDate = (source = {}) => (
  toIsoStringOrNull(
    source.originDate
    || source.selectedDate
    || source.date
    || source.sourceDate
    || source.timestamp
    || source.createdAt
    || source.metadata?.selectedDate
    || source.metadata?.sourceDate
  )
);

export const getMedicationReviewOriginSourceId = (source = {}) => (
  normalizeText(
    source.originSourceId
    || source.sourceId
    || source.sourceNoteId
    || source.id
  )
);

export const buildMedicationReviewNavigationState = ({
  childId = '',
  returnTo = '/dashboard',
  originEntryId = '',
  originDate = null,
  originSourceId = '',
  sourceText = '',
  medicationSuggestion = null,
} = {}) => ({
  childId: normalizeText(childId),
  returnTo: normalizeText(returnTo) || '/dashboard',
  originEntryId: normalizeText(originEntryId),
  originDate: toIsoStringOrNull(originDate),
  originSourceId: normalizeText(originSourceId),
  ...(normalizeText(sourceText) ? { sourceText: normalizeText(sourceText) } : {}),
  ...(medicationSuggestion && typeof medicationSuggestion === 'object'
    ? { medicationSuggestion }
    : {}),
});

export const getMedicationReviewNavigationContext = (state = {}) => {
  const context = buildMedicationReviewNavigationState(state);
  return {
    ...context,
    hasOriginContext: Boolean(context.returnTo && (context.originEntryId || context.originDate || context.originSourceId)),
  };
};

export const buildMedicationReviewReturnState = (context = {}) => {
  const normalized = getMedicationReviewNavigationContext(context);
  return {
    childId: normalized.childId || null,
    timelineEntryId: normalized.originEntryId || null,
    selectedDate: normalized.originDate || null,
    originEntryId: normalized.originEntryId || null,
    originDate: normalized.originDate || null,
    originSourceId: normalized.originSourceId || null,
  };
};
